import { Box, Typography, TextField, Grid, FormControl, InputLabel, MenuItem, FormControlLabel, Checkbox, InputAdornment, IconButton } from '@mui/material';
import React, { useState } from 'react';
import KenButton from '../../GlobalComponents/KenButton';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '100%', sm: '100%', md: '100%', xl: '558px', lg: '558px' },
  height: { xs: '100%', sm: '100%', md: '100%', xl: '617px', lg: '617px' },
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '9px',
  p: 4,
};

const ScheduleForm = (props: any) => {
  const [mentor, setMentor] = React.useState('');
  const [mileStone, setMileStone] = React.useState('');
  const [goal, setGoal] = React.useState('');

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  const handleChangeMentor = (event: SelectChangeEvent) => {
    setMentor(event.target.value as string);
  };
  const handleChangeMilestone = (event: SelectChangeEvent) => {
    setMileStone(event.target.value as string);
  };
  const handleChangeGoal = (event: SelectChangeEvent) => {
    setGoal(event.target.value as string);
  };
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);

      // Create a preview of the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div>
      <Box sx={style} className="scrollbar-cusgray">
        <Typography sx={{ fontSize: '15px', fontWeight: 500 }}>Schedule a Call</Typography>
        <hr />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Choose Mentor</Typography>
            <Box sx={{ width: '100%', mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', margin: '-5px' }}>
                  Select
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={mentor}
                  label="Age"
                  onChange={handleChangeMentor}
                  size="small"
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF', 
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                    },
                    '& .MuiSelect-select': {
                      fontSize: '12px',
                    },
                  }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Jabastin
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Sam Mattew
                  </MenuItem>
                  <MenuItem
                    value={30}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Rubina atwal
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Select Slot</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']} sx={{ width: '100%', mt: 1, overflow: 'hidden' }}>
                <DatePicker
                  label="Choose Dates"
                  sx={{ width: '100%' }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: {
                        '& .MuiInputBase-root': {
                          height: '36px',
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '12px',
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  sx={{
                    '& .MuiSvgIcon-root': {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="Does not repeat"
              sx={{
                '& .MuiFormControlLabel-label': {
                  fontSize: '12px',
                },
              }}
            />
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Link to Milestone</Typography>
            <Box sx={{ width: '100%', mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', margin: '-5px' }}>
                  Select
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={mileStone}
                  label="Age"
                  onChange={handleChangeMilestone}
                  size="small"
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF', 
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                    },
                    '& .MuiSelect-select': {
                      fontSize: '12px',
                    },
                  }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Community Engagement
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Entrepreneurial Ventures
                  </MenuItem>
                  <MenuItem
                    value={30}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Professional Achievements
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Upload Document</Typography>
            <TextField
              sx={{
                mt: 2,
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              variant="outlined"
              fullWidth
              size="small"
              placeholder="Upload document"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton component="label">
                      <input type="file" hidden accept="image/*" onChange={handleFileChange} />
                      <FileUploadOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Add Descriptions</Typography>
            <TextField
              id="outlined-basic"
              placeholder="Enter Description"
              variant="outlined"
              rows={2}
              fullWidth
              sx={{
                mt: 2,
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Title</Typography>
            <TextField
              id="outlined-basic"
              placeholder="Enter title"
              variant="outlined"
              fullWidth
              sx={{
                mt: 2,
                height: '36px',
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              size="small"
            />
            <Box sx={{ mt: 5.8 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['TimePicker']} sx={{ width: '100%', mt: 1, overflow: 'hidden' }}>
                  <TimePicker
                    label="Basic time picker"
                    sx={{ width: '100%' }}
                    slotProps={{
                      textField: {
                        size: 'small',
                        sx: {
                          '& .MuiInputBase-root': {
                            height: '36px',
                          },
                          '& .MuiInputLabel-root': {
                            fontSize: '12px',
                          },
                        },
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>

            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 6.4 }}>Link to Goal</Typography>
            <Box sx={{ width: '100%', mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', margin: '-5px' }}>
                  Select
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={goal}
                  label="Age"
                  onChange={handleChangeGoal}
                  size="small"
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF', 
                    },
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                    },
                    '& .MuiSelect-select': {
                      fontSize: '12px',
                    },
                  }}
                >
                  <MenuItem
                    value={10}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Networking
                  </MenuItem>
                  <MenuItem
                    value={20}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Entrepreneurship
                  </MenuItem>
                  <MenuItem
                    value={30}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: 'transparent',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:hover': {
                        backgroundColor: 'transparent',
                      },
                      '&:active': {
                        backgroundColor: 'transparent',
                      },
                    }}
                  >
                    Career Advancement
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, mt: 2 }}>Add Participants</Typography>
            <TextField
              id="outlined-basic"
              placeholder="Enter Participants"
              variant="outlined"
              fullWidth
              sx={{
                mt: 2,
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
              }}
              size="small"
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item sm={12} md={12} lg={6} xl={6} />
          <Grid item sm={12} md={12} lg={6} xl={6}>
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
              <KenButton
                variant="text"
                sx={{
                  mt: 2,
                  borderRadius: '8px',
                  fontweight: 500,
                  backgroundColor: 'none',
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  color: 'black',
                  width: 100,
                }}
                onClick={props.handleClose}
                fullWidth
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Cancel</Typography>
              </KenButton>
              <KenButton
                variant="contained"
                onClick={props.handleClose}
                style={{
                  width: 150,
                  marginTop: 15,
                  borderRadius: '7px',
                  boxShadow: 'none',
                  '&:hover': {
                    boxShadow: 'none',
                  },
                }}
                fullWidth
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Request for call</Typography>
              </KenButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ScheduleForm;
